import './scripts/common';
import './scripts/common-nav';

let _config = window['_config'] || {};

// @ts-ignore
window.app = window['app'] || {
    debug: false,
};

// Todo: Add page specific JS here e.g:
import * as fadeIn from './scripts/fade-in';
fadeIn.init();

import * as selectLoadUrl from './scripts/select-load-url';
selectLoadUrl.init();

import * as ajaxForm from '@elements/ajax-form';
ajaxForm.init({
    addUrlParams: true
});

import * as ajaxModal from './scripts/ajax-modal';
ajaxModal.init();

import * as actionChanger from '@elements/action-changer';
actionChanger.init();

import { onFind } from '@elements/init-modules-in-scope';
import { findIn, on, find } from '@elements/dom-utils';
import Modal from 'bootstrap/js/dist/modal';

let currentOpenedModalId = undefined
onFind('.js-delete-number-modal-open', (btn) => {
    on('click', () => {
        currentOpenedModalId = btn.getAttribute('data-delete-number-form-id')
    }, btn)
})

onFind('.js-delete-number-modal', (modal) => {
    const myModal = new Modal(modal)
    const deleteSubmit = findIn('.js-delete-number-modal-submit', modal)

    if(deleteSubmit) {
        deleteSubmit.addEventListener('click', () => {
            const form = find(`[data-delete-number-form-id='${currentOpenedModalId}']`)
            if(form) {
                // change action manually, because action changer is not working on JS-submit
                const action = form.dataset.action
                form.setAttribute("action", action)
                form.submit()
            }
        })
    }
})

import * as datepicker from "@elements/datepicker";
datepicker.init({
    minDate: null
});

import * as datepickerRange from "@elements/datepicker-range";
datepickerRange.init();
